import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  if (!userInfo) {
    // user is not authenticated
    return <Navigate to="/" />;
  }
  return children;
};